import * as React from "react";

import axios from "axios";

import { Link, useNavigate } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {
  RiBuilding2Line,
  RiUserLine,
  RiUserAddLine,
  RiArrowLeftLine,
  RiArrowRightLine,
  RiFileEditLine,
  RiCalculatorLine,
} from "react-icons/ri";

import Textfield from "../../Components/Textfield";
import Button from "../../Components/Button";
import Select from "../../Components/Select";
import CustomRadio from "../../Components/CustomRadio";
import SidebarRightFinancingRequestNotConnected from "../../Components/SidebarRightFinancingRequestNotConnected";

import { useToast } from "../../Context/ToastContext";
import { useLoader } from "../../Context/LoaderContext";

import Logo from "./../../Images/logo_white.png";

import "./FinancingRequestNotConnected.scss";

const initialFormState = {
  // Compnay Intial Form
  request_type: "professional",

  client_name: "",
  manager_name: "",
  cin: "",
  request_subject: "",
  tax_id: "",
  activity_sector_id: "",

  email: "",
  phone: "",
  fax: "",
  postal_code: "",
  address: "",
  city: "",
};

const FinancingRequestNotConnectedStep1 = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessages, setFormErrorMessages] = React.useState("");
  const [cities, setCities] = React.useState([]);
  const [activitySectors, setActivitySectors] = React.useState([]);

  const navigate = useNavigate();

  const { addToast } = useToast();
  const { setIsLoading } = useLoader();

  React.useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/cities`).then((response) => {
      setCities(response.data?.data || []);
    });
  }, []);

  React.useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/activity-sectors`)
      .then((response) => {
        setActivitySectors(response.data?.data || []);
      });
  }, []);

  React.useEffect(() => {
    setIsLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/get-request-with-simulation`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          "Access-Token": localStorage.getItem(
            process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN_OFFLINE
          ),
        },
      })
      .then((response) => {
        setIsLoading(false);
        setValRegister(response.data?.data || []);
      })
      .catch((error) => {
        setIsLoading(false);

        console.error("Error fetching data:", error);
      });
  }, [setIsLoading]);

  const handleChangeField = (val, key) => {
    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: "",
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: val,
    }));

    if (key === "postal_code") {
      const selectedCity = cities.find(
        (city) => city.zip_code === parseInt(val, 10)
      );
      if (selectedCity) {
        setValRegister((prev) => ({
          ...prev,
          governorate: selectedCity.governorate,
          city: selectedCity.governorate + " (" + selectedCity.title + ") ",
        }));
      } else {
        setValRegister((prev) => ({
          ...prev,
          governorate: "",
          city: "",
        }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/financing-request/update`,
        {
          request_type: valRegister.request_type,
          client_name: valRegister.client_name,
          manager_name: valRegister.manager_name,
          cin: valRegister.cin,
          request_subject: valRegister.request_subject,
          tax_id: valRegister.tax_id,
          activity_sector_id: valRegister.activity_sector_id,
          email: valRegister.email,
          fax: valRegister.fax,
          phone: valRegister.phone,
          address: valRegister.address,
          city: valRegister.city,
          postal_code: valRegister.postal_code,
          step: "customer_information",
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            "Access-Token": localStorage.getItem(
              process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN_OFFLINE
            ),
          },
        }
      )
      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          addToast({
            variant: "success",
            message: response.data.message,
          });
          navigate("/documents");
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  return (
    <div className="layout-app layout-not-connected ">
      <div className="sideBar sideBar-not-connected">
        <Link to="/" className="logo logo-white">
          <img
            src={Logo}
            alt="Attijari Leasing Tunisie, Crédit Leasing Tunisie | Attijari"
          />
        </Link>
        <div className="title-sidebar-not-connected active">
          Lancez votre projet Leasing
        </div>
        <div className="menu-sidebar-not-connected">
          <RiCalculatorLine /> Simulations
        </div>
        <div className="menu-sidebar-not-connected active">
          <RiFileEditLine /> Demande de Financement
        </div>
      </div>
      <div className="wrap-app wrap-app-not-connected">
        <div className="topBarNotConnected">
          <Row>
            <Col md={12}>
              <div className="wrapTopBarNotConnected">
                <Link to="/simulations" className="link-back">
                  <RiArrowLeftLine />
                </Link>

                <div className="title-topBarNot">Informations Clients</div>
                <div className="description-topBarNot">
                  Fournissez les détails de votre entreprise pour identifier
                  clairement le demandeur du financement.
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <div className="container-app container-app-not-connected">
          <div className="wrap-steps-sidebar-not-connected">
            <div className="steps-sidebar-not-connected active">
              1. Informations Clients
            </div>

            <div className="steps-sidebar-not-connected">
              2. Documents à Joindre
            </div>
            <div className="steps-sidebar-not-connected">3. Récapitulatif</div>
          </div>
          <Row>
            <Col md={8}>
              <div className="wrap-financing-request">
                <form
                  className="financing-request"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <div className="step-financing-request">
                    <label htmlFor="product_name" className="bold d-block mb-2">
                      Choisir type de client
                    </label>
                    <div
                      className={` mb-2 wrap-radios ${
                        formErrorMessages.product_name ? "error-radio" : ""
                      }`}
                    >
                      <CustomRadio
                        label="Professionnel"
                        id="professional"
                        className="bg_white"
                        icone={<RiUserLine />}
                        name="request_type"
                        value="professional"
                        onChange={(e) => {
                          if (e.target.checked)
                            handleChangeField(e.target.value, "request_type");
                        }}
                        checked={valRegister.request_type === "professional"}
                      />
                      <CustomRadio
                        label="Agriculteur"
                        id="farmer"
                        className="bg_white"
                        icone={<RiUserAddLine />}
                        name="request_type"
                        value="farmer"
                        onChange={(e) => {
                          if (e.target.checked)
                            handleChangeField(e.target.value, "request_type");
                        }}
                        checked={valRegister.request_type === "farmer"}
                      />

                      <CustomRadio
                        label="Entreprise"
                        id="company"
                        className="bg_white"
                        icone={<RiBuilding2Line />}
                        name="request_type"
                        value="company"
                        onChange={(e) => {
                          if (e.target.checked)
                            handleChangeField(e.target.value, "request_type");
                        }}
                        checked={valRegister.request_type === "company"}
                      />
                      {formErrorMessages.request_type && (
                        <div className="text-danger">
                          {formErrorMessages.request_type}
                        </div>
                      )}
                    </div>
                    <h2 className="title_form">Identité de la société</h2>
                    <Textfield
                      label="Nom du client"
                      name="client_name"
                      required
                      type="text"
                      placeholder="Veuillez insérer votre nom du client"
                      size="large"
                      value={valRegister.client_name}
                      onChange={(e) =>
                        handleChangeField(e.target.value, "client_name")
                      }
                      hasError={formErrorMessages.client_name}
                      errorMessage={
                        formErrorMessages.client_name && (
                          <div className="text-danger">
                            {formErrorMessages.client_name}
                          </div>
                        )
                      }
                    />
                    {valRegister.request_type === "company" && (
                      <Textfield
                        label="Nom du gérant"
                        name="manager_name"
                        required
                        type="text"
                        placeholder="Veuillez insérer votre nom du gérant"
                        size="large"
                        value={valRegister.manager_name}
                        onChange={(e) =>
                          handleChangeField(e.target.value, "manager_name")
                        }
                        hasError={formErrorMessages.manager_name}
                        errorMessage={
                          formErrorMessages.manager_name && (
                            <div className="text-danger">
                              {formErrorMessages.manager_name}
                            </div>
                          )
                        }
                      />
                    )}
                    <Textfield
                      label={
                        valRegister.request_type === "company"
                          ? "CIN du gérant"
                          : "CIN"
                      }
                      name="cin"
                      required
                      type="text"
                      placeholder={
                        valRegister.request_type === "company"
                          ? "Veuillez insérer votre CIN du gérant"
                          : "Veuillez insérer votre CIN"
                      }
                      size="large"
                      value={valRegister.cin}
                      onChange={(e) => handleChangeField(e.target.value, "cin")}
                      hasError={formErrorMessages.cin}
                      errorMessage={
                        formErrorMessages.cin && (
                          <div className="text-danger">
                            {formErrorMessages.cin}
                          </div>
                        )
                      }
                    />
                    <Textfield
                      label="Objet de la demande"
                      name="request_subject"
                      required
                      type="text"
                      placeholder="Veuillez insérer votre objet de la demande"
                      size="large"
                      value={valRegister.request_subject}
                      onChange={(e) =>
                        handleChangeField(e.target.value, "request_subject")
                      }
                      hasError={formErrorMessages.request_subject}
                      errorMessage={
                        formErrorMessages.request_subject && (
                          <div className="text-danger">
                            {formErrorMessages.request_subject}
                          </div>
                        )
                      }
                    />
                    <Textfield
                      label="Matricule Fiscale"
                      name="tax_id"
                      required={
                        valRegister.request_type === "professional" ||
                        valRegister.request_type === "company"
                      }
                      type="text"
                      placeholder="Veuillez insérer votre matricule fiscale"
                      size="large"
                      value={valRegister.tax_id}
                      onChange={(e) =>
                        handleChangeField(e.target.value, "tax_id")
                      }
                      hasError={formErrorMessages.tax_id}
                      errorMessage={
                        formErrorMessages.tax_id && (
                          <div className="text-danger">
                            {formErrorMessages.tax_id}
                          </div>
                        )
                      }
                    />

                    {valRegister.request_type === "farmer" ? (
                      <Textfield
                        label="Secteur d'Activité"
                        disabled
                        required={
                          valRegister.request_type === "professional" ||
                          valRegister.request_type === "company"
                        }
                        type="text"
                        size="large"
                        value="AGRICULTURE"
                      />
                    ) : (
                      <Select
                        label="Secteur d'Activité"
                        id="activity_sector_id"
                        required
                        value={valRegister.activity_sector_id || ""}
                        onChange={(e) =>
                          handleChangeField(
                            e.target.value,
                            "activity_sector_id"
                          )
                        }
                        hasError={formErrorMessages.activity_sector_id}
                        errorMessage={
                          <div className="text-danger">
                            {formErrorMessages.activity_sector_id}
                          </div>
                        }
                      >
                        <option value=""></option>
                        {activitySectors.map((sector) => (
                          <option key={sector.id} value={sector.id}>
                            {sector.title}
                          </option>
                        ))}
                      </Select>
                    )}

                    <h2 className="title_form mt-40">
                      Coordonnés de l'entreprise
                    </h2>
                    <Textfield
                      label="Email"
                      name="email"
                      required={
                        valRegister.request_type === "professional" ||
                        valRegister.request_type === "company"
                      }
                      type="text"
                      placeholder="Veuillez insérer votre email"
                      size="large"
                      value={valRegister.email}
                      onChange={(e) =>
                        handleChangeField(e.target.value, "email")
                      }
                      hasError={formErrorMessages.email}
                      errorMessage={
                        formErrorMessages.email && (
                          <div className="text-danger">
                            {formErrorMessages.email}
                          </div>
                        )
                      }
                    />
                    <Row>
                      <Col md={6}>
                        <Textfield
                          label="Téléphone"
                          name="phone"
                          required
                          type="text"
                          placeholder="Veuillez insérer votre téléphone"
                          size="large"
                          value={valRegister.phone}
                          onChange={(e) =>
                            handleChangeField(e.target.value, "phone")
                          }
                          hasError={formErrorMessages.phone}
                          errorMessage={
                            formErrorMessages.phone && (
                              <div className="text-danger">
                                {formErrorMessages.phone}
                              </div>
                            )
                          }
                        />
                      </Col>
                      <Col md={6}>
                        <Textfield
                          label="Fax"
                          name="fax"
                          type="text"
                          placeholder="Veuillez insérer votre fax"
                          size="large"
                          value={valRegister.fax}
                          onChange={(e) =>
                            handleChangeField(e.target.value, "fax")
                          }
                          hasError={formErrorMessages.fax}
                          errorMessage={
                            formErrorMessages.fax && (
                              <div className="text-danger">
                                {formErrorMessages.fax}
                              </div>
                            )
                          }
                        />
                      </Col>
                    </Row>
                    <Textfield
                      label="Adresse"
                      name="address"
                      required
                      type="text"
                      placeholder="Veuillez insérer votre adresse"
                      size="large"
                      value={valRegister.address}
                      onChange={(e) =>
                        handleChangeField(e.target.value, "address")
                      }
                      hasError={formErrorMessages.address}
                      errorMessage={
                        formErrorMessages.address && (
                          <div className="text-danger">
                            {formErrorMessages.address}
                          </div>
                        )
                      }
                    />

                    <Select
                      label="Code Postal"
                      id="postal_code"
                      required
                      value={valRegister.postal_code || ""}
                      onChange={(e) =>
                        handleChangeField(e.target.value, "postal_code")
                      }
                      hasError={formErrorMessages.postal_code}
                      errorMessage={
                        <div className="text-danger">
                          {formErrorMessages.postal_code}
                        </div>
                      }
                    >
                      <option value="">--</option>
                      {cities.map((city, index) => (
                        <option key={index} value={city.zip_code}>
                          {city.zip_code}
                        </option>
                      ))}
                    </Select>

                    <Textfield
                      autoComplete="off"
                      label="Ville"
                      name="city"
                      type="text"
                      size="large"
                      disabled
                      required
                      value={valRegister.city}
                      onChange={(e) =>
                        handleChangeField(e.target.value, "city")
                      }
                      hasError={formErrorMessages.city}
                      errorMessage={
                        formErrorMessages.city && (
                          <div className="text-danger">
                            {formErrorMessages.city}
                          </div>
                        )
                      }
                    />
                  </div>

                  <div className="wrap-btn-action-request">
                    <Button type="submit">
                      Suivant <RiArrowRightLine />
                    </Button>
                  </div>
                </form>
              </div>
            </Col>
            <Col md={4}>
              <SidebarRightFinancingRequestNotConnected />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default FinancingRequestNotConnectedStep1;
